import { createMuiTheme } from '@material-ui/core/styles';
import { HIRAGINO_FONT, SERVICE_COLOR_3 } from '../../core/styles/variables';
import { servicePaletteOptions } from '../../core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#E1EEEF',
      main: '#1A8F98',
      dark: '#30868D',
    },
    text: {
      primary: '#333333',
    },
  },
  typography: {
    fontFamily: HIRAGINO_FONT,
  },
  props: {
    backgroundColor: SERVICE_COLOR_3,
    palette: servicePaletteOptions,
  },
});

export default theme;
